import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { loggedInUser } from '@/services/authentication';
import { eventBus } from '@/eventBus';
import { DEFAULT_LOCALE } from '@/constants';
import messages from './messages';
import numberFormats from './numberFormats';
import dateTimeFormats from './dateTimeFormats';

Vue.use(VueI18n);

const user = loggedInUser();
const locale = (user && user.locale) ? user.locale : DEFAULT_LOCALE;
document.documentElement.setAttribute('lang', locale);

const i18n = new VueI18n({
    locale,
    silentFallbackWarn: true,
    silentTranslationWarn: true,
    formatFallbackMessages: true,
    numberFormats,
    dateTimeFormats,
    messages,
});

eventBus.$on('login', (userLoggingIn) => {
    i18n.locale = userLoggingIn.locale ? userLoggingIn.locale : DEFAULT_LOCALE;
    document.documentElement.setAttribute('lang', i18n.locale);
});

eventBus.$on('user-updated', (updatedUser) => {
    i18n.locale = updatedUser.locale ? updatedUser.locale : DEFAULT_LOCALE;
    document.documentElement.setAttribute('lang', i18n.locale);
});

eventBus.$on('logout', () => {
    i18n.locale = DEFAULT_LOCALE;
    document.documentElement.setAttribute('lang', i18n.locale);
});

export default i18n;
